import {
  ORGANES_FETCHING,
  FETCH_ORGANES,
  FIND_ORGANE,
} from "../actions/types";

const initialState = {
  items: [],
  loadedItems: [],
  filteredItems: [],
  isFetching: false,
  limit: 0,
  offset: 0,
  loader: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ORGANES_FETCHING:
      return { ...state, isFetching: true };

    case FETCH_ORGANES:
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.loaded,
        loader: action.payload.loader,
        isFetching: false,
      };

    case FIND_ORGANE:
      return {
        ...state,
        items: [...state.items, action.payload],
      };

    default:
      return state;
  }
}
